<template lang="pug">
  v-row.px-5

    confirm-dialog(ref="cdConfirmModal" :title="cdParameters.title" :text="cdParameters.text" :buttonPosition="cdParameters.buttonPosition" :width="cdParameters.width" @close="cdAction")

    v-col(cols="12")
      v-row(justify="space-between")
        v-col
          h2.blockTitle Séries
          span.blockDescription Jornadas de trabalho, férias e folgas criadas em série

        v-col
          v-row(class="d-flex flex-column" justify="end" align="end")
            div.searchBlock
              v-icon(size="18" class="searchFieldIcon") mdi-magnify
              input(type="text" v-model="query" maxlength="56" placeholder="Pesquise pelo nome da série" class="searchField" :disabled="loading")
      v-row(class="d-flex flex-column" justify="end" align="end")
        sos-button(@buttonClick="goToCreateSeries" size="medium" buttonLabel="NOVA SÉRIE" color="success" buttonIcon="mdi-plus" buttonIconSize="16" class="mr-3")


    v-col(cols="12")
      .pageBody

        //-
          -
          - AGUARDANDO
          -
          -

        .groupsContainer(v-if="loading")

          .loadingResult

            .buttonLoader
              span
            span.loadingText Inicializando...

        //-
          -
          - ERRO NO CARREGAMENTO/PROCESSAMENTO
          -
          -
        .groupsContainer(v-else-if="searchError")

          .text-center

            span.startTitle Não foi possível carregar a lista!
            br
            .pt-2
              span Por favor, recarregue a página ou&nbsp;
              a(href="https://wa.me/?phone=5513992061010" target="_blank") converse com o nosso suporte.

        //-
          -
          - CARREGOU, MAS NÃO TEM ITENS VÁLIDOS
          -
          -

        .groupsContainer(v-else-if="!items.length")

          .text-center
            .pt-2 Não foram encontradas séries para esta pesquisa

        //-
          -
          - CARREGOU E TEM ITENS VÁLIDOS
          -
          -

        .groupsContainer(v-else)

          table#managerUsersTable(border="0" cellspacing="0" cellpadding="0")

            thead

              tr.managerUserItem.managerUserItemHeader
                th Série
                th Grupo
                th Escalas
                th Tipo
                th(width="300") Repetição
                th Início
                th Término
                th(width="100").last Ações

            tbody

              tr(v-for="(series, index) in items" :key="'usuario_' + index" :class="{ 'last': items.length === index + 1 }")

                td(data-label="Série")

                  span {{ series.name }}

                td(data-label="Grupo")

                  span {{ groups[series.group_id] }}

                td(data-label="Escalas")

                  span {{ getScaleNames(series.scales) }}

                td(data-label="Tipo")

                  span {{ series.type }}

                td(data-label="Repetição")

                  span {{ series.repetition }}

                td(data-label="Início")

                  span {{ formatDate(series.start_date) }}

                td(data-label="Término")

                  span {{ formatDate(series.end_date) }}

                td(data-label="Ações").last.py-3

                  sos-button(@buttonClick="openCopyDialog(series.id, series.group_id)" size="small" color="success" buttonLabel="" buttonIcon="mdi-clipboard-multiple" buttonIconSize="16").mr-3
                  sos-button(@buttonClick="openDeleteDialog(series.id)" size="small" color="danger" buttonLabel="" buttonIcon="mdi-delete" buttonIconSize="16")

        //-
          -
          - PAGINAÇÃO
          -
          -
        nav.userManagerNav(v-if="totalPages > 1")
          .userManagerNavColumn--pages.w-100
            a(id="navFirst" @click.prevent="currentPage = 1" :class="{ 'disabled': currentPage === 1 }" :disabled="currentPage === 1") &#8249;&#8249;
            a(id="navPrev" @click.prevent="currentPage = currentPage - 1" :class="{ 'disabled': currentPage === 1 }" :disabled="currentPage === 1") &#8249;
            a(v-for="page in visiblePages" :key="page" @click.prevent="setPage(page)" :class="{ 'current': currentPage === page }") {{ page }}
            a(id="navNext" @click.prevent="currentPage = currentPage + 1" :class="{ 'disabled': currentPage === totalPages }" :disabled="currentPage === totalPages") &#8250;
            a(id="navLast" @click.prevent="currentPage = totalPages" :class="{ 'disabled': currentPage === totalPages }" :disabled="currentPage === totalPages") &#8250;&#8250;

</template>

<script>
import ConfirmDialog from "@/modals/ConfirmDialog";
import confirmDialogMixin from "@/mixins/cd.mixin.js";
import StepHeader from "@/components/StepHeader";
import SosButton from "@/components/SosButton";
import * as types from "@/store/group-series/types";
import { mapGetters, mapActions, mapState } from "vuex";
import { getScalesByGroupID } from "@/services/firebase";
import moment from "moment";

export default {
  name: "SeriesIndex",

  components: {
    StepHeader,
    "sos-button": SosButton,
    "confirm-dialog": ConfirmDialog,
  },

  mixins: [confirmDialogMixin],

  data() {
    return {
      scales: {},
      users: {},
      query: "",
      loading: false,
      loadingGroupsAndScales: false,
      querySearchEnabled: false,
      searchError: false,
      currentPage: 1,
      searchTimeout: null,
      cdParameters: {
        title: "",
        text: "",
        buttonPosition: "right",
        width: 330,
      },
    };
  },

  computed: {
    ...mapGetters({
      searchResults: types.SERIES_SEARCH_RESULTS,
    }),
    ...mapState({
      userGroups: state => state.app.groups,
    }),
    groups: function () {
      if (this.userGroups && this.userGroups.length) {
        const groupMap = {};
        this.userGroups.forEach((group) => {
          groupMap[group.groupID] = group.groupName;
        });
        return groupMap;
      }
      return {};
    },
    items: function () {
      return this.searchResults?.data || [];
    },
    totalItems: function () {
      return this.searchResults?.total || 0;
    },
    totalPages: function () {
      return this.searchResults?.total_pages || 0;
    },
    visiblePages: function () {
      const pages = [];
      const totalPages = this.totalPages;
      const currentPage = this.currentPage;
      if (totalPages <= 5) {
        for (let i = 1; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        if (currentPage <= 3) {
          pages.push(1, 2, 3, 4, "...", totalPages);
        } else if (currentPage >= totalPages - 2) {
          pages.push(
            1,
            "...",
            totalPages - 3,
            totalPages - 2,
            totalPages - 1,
            totalPages
          );
        } else {
          pages.push(
            1,
            "...",
            currentPage - 1,
            currentPage,
            currentPage + 1,
            "...",
            totalPages
          );
        }
      }
      return pages;
    },
  },

  async mounted() {
    this.loading = true;
    this.search();
  },

  watch: {
    query(newValue) {
      if (!newValue || newValue.length >= 3) {
        this.querySearchEnabled = true;
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
          this.currentPage = 1;
          this.search();
        }, 300); // Delay of 300ms
      } else {
        this.querySearchEnabled = false;
      }
    },
    currentPage(newValue) {
      if (newValue < 1) {
        this.currentPage = 1;
      } else if (newValue > this.totalPages) {
        this.currentPage = this.totalPages;
      }
      this.search();
    },
  },

  methods: {
    ...mapActions({
      searchSeries: types.SEARCH_SERIES,
      deleteSeries: types.DELETE_SERIES,
    }),
    goToCreateSeries() {
      this.$router.push("/admin/series/form");
    },
    search() {
      this.loading = true;
      this.querySearchEnabled = true;
      this.searchError = false;
      this.searchSeries({
        query: this.query,
        page: this.currentPage,
      })
        .then(() => {
          this.searchError = false;
          this.items.forEach((series) => {
            this.fillScales(series.group_id);
          });
        })
        .catch((error) => {
          this.searchError = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setPage(page) {
      this.currentPage = page;
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    openCopyDialog(id, group_id) {
      this.showDialog(
        "Copiar série",
        "Iremos redirecionar para uma cópia da desta série. Deseja continuar?",
        "copy",
        { id, group_id }
      );
    },
    openDeleteDialog(id) {
      this.showDialog(
        "Deseja cancelar?",
        "A série não poderá ser recuperada depois de removida. Deseja continuar?",
        "delete",
        id
      );
    },
    cdAction(cdResponse) {
      // console.log("cdResponse", cdResponse);
      if (cdResponse === false) return;
      if (cdResponse.cdType === "delete") {
        this.delete(cdResponse.cdData);
      } else if (cdResponse.cdType === "copy") {
        this.$router.push(
          `/admin/series/${cdResponse.cdData.group_id}/form/${cdResponse.cdData.id}/copiar`
        );
      }
    },
    delete(id) {
      this.deleteSeries(id)
        .then(() => {
          this.currentPage = 1;
          this.search();
        })
        .catch((error) => {
          const errorData = error?.response?.data || {
            title: "Erro",
            message: "Erro ao criar série",
          };
          this.showMessage(errorData.title, errorData.message);
        });
    },

    async fillScales(groupId) {
      const groupScales = await getScalesByGroupID(groupId);
      for (let j = 0; j < groupScales.length; j++) {
        const scale = groupScales[j];
        if (scale.length > 1) {
          this.$set(this.scales, scale[0], scale[1].type);
        }
      }
    },

    getScaleNames(scales) {
      if (!scales) return [];
      const scaleNames = [];
      for (let i = 0; i < scales.length; i++) {
        const scaleID = scales[i].scale_id;
        if (this.scales.hasOwnProperty(scaleID)) {
          scaleNames.push(this.scales[scaleID]);
        }
      }
      return scaleNames.join(", ");
    },
  },
};
</script>

<style lang="scss" scoped>
.searchFieldIcon {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto 0 !important;
  left: 12px;
}

.searchField {
  width: 100%;
  // max-width: 320px;
  height: 100%;
  background-color: #ffffff;
  padding: 0 20px 0 40px;
  border-radius: 10px;
  border: 0;
  outline: 0;
  box-shadow: 1px 2px 2px -1px rgba(0, 0, 0, 0.25);
  font-size: 15px;

  &:disabled {
    background-color: #cccccc;
  }
}

.searchBlock {
  position: relative;
  display: inline-block;
  width: 100%;
  // max-width: 320px;
  max-width: 390px;
  height: 40px;
}

td {
  span {
    text-align: left;
    color: #444444;
    font-size: 15px;
    line-height: 30px;
  }
}
</style>
